import styled from 'styled-components';

import {
  device
} from '../../utils';

export const Wrapper = styled.div `
  margin-top: 55px;
  background: #FFF;
`;

export const Title = styled.h2 `
  font-size: 20px;
  font-weight: 900;
  color: #111111;
  margin: 0 0 15px 0;
  text-align: left;
`;

export const Grid = styled.div `
  @media ${device.tabletDown} {
    & > *:nth-child(n + 3) {
      display: none;
    }
  }
`;